import * as PropTypes from "prop-types"
import styled from "styled-components"
import YouTube from "react-youtube"
import { Container } from "../styled/Grid"

const VideoContainer = styled.div`
  height: 0;
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;

  iframe,
  object,
  embed {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`

/**
 * @type import('react-youtube').Options
 */
const opts = {
  playerVars: { modestbranding: 1, rel: 0, enablejsapi: 1, origin: "https://swipcar.com" }
}

function YoutubeVideo({ youtubeId, onPlay, onReady, ...rest }) {
  return (
    <Container {...rest}>
      <VideoContainer>
        <YouTube videoId={youtubeId} opts={opts} onPlay={onPlay} onReady={onReady} />
      </VideoContainer>
    </Container>
  )
}

YoutubeVideo.defaultProps = {
  onPlay: () => {},
  onReady: () => {}
}

YoutubeVideo.propTypes = {
  youtubeId: PropTypes.string.isRequired,
  onPlay: PropTypes.func,
  onReady: PropTypes.func
}

export default YoutubeVideo
